import { createFeature, createReducer, on, createSelector, createAction, props } from '@ngrx/store';
import { CommonApiState } from './common';
import { Task } from '../models/task';

export const TaskDetailsFetch = createAction('[TaskDetails] Fetch', props<{ workspaceId: string; taskId: string }>());
export const TaskDetailsFetched = createAction('[TaskDetails] Fetched', props<{ task: Task }>());
export const TaskDetailsError = createAction('[TaskDetails] Error', props<{ taskId: string }>());

export const initialState: Record<string, CommonApiState<Task>> = {};

export const taskDetailsFeature = createFeature({
  name: 'taskDetails',
  reducer: createReducer(
    initialState,
    on(TaskDetailsFetch, (state, action) => ({
      ...state,
      [action.taskId]: {
        ...(state[action.taskId] ?? {}),
        currentPedingApis: (state[action.taskId]?.currentPedingApis ?? 0) + 1
      }
    })),
    on(TaskDetailsFetched, (state, action) => {
      return {
        ...state,
        [action.task.task_id]: {
          ...(state[action.task.task_id] ?? {}),
          currentPedingApis: 0,
          data: action.task
        }
      };
    }),
    on(TaskDetailsError, (state, action) => {
      return {
        ...state,
        [action.taskId]: {
          ...(state[action.taskId] ?? {}),
          currentPedingApis: 0,
          isError: true
        }
      };
    })
  ),
  extraSelectors: ({ selectTaskDetailsState }) => {
    const taskDetailsIsLoading = (taskId: string) =>
      createSelector(selectTaskDetailsState, taskState => (taskState[taskId]?.currentPedingApis ?? 0) > 0);

    const taskDetailsHasPendingRequest = (taskId: string) =>
      createSelector(selectTaskDetailsState, taskState => (taskState[taskId]?.currentPedingApis ?? 0) >= 2);
    const taskDetailsData = (taskId: string) => {
      return createSelector(selectTaskDetailsState, taskDetailsState => {
        return taskDetailsState[taskId]?.data;
      });
    };

    return { taskDetailsIsLoading, taskDetailsHasPendingRequest, taskDetailsData };
  }
});
